import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/programLog',
  title: window.language['system.programLog.title'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('../Org/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/ProgramLog/index.js